import { useAuth } from '../contexts/AuthContext';

export default function DebugAuth() {
  const { currentUser, userProfile, membership, loading, hasRole, isActiveMember } = useAuth();

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow rounded-lg">
      <h2 className="text-2xl font-bold mb-6">🔍 Authentication Debug Info</h2>
      
      <div className="space-y-4">
        <div className="bg-gray-50 p-4 rounded">
          <h3 className="font-bold text-lg mb-2">Loading State:</h3>
          <p>{loading ? '⏳ Loading...' : '✅ Loaded'}</p>
        </div>

        <div className="bg-gray-50 p-4 rounded">
          <h3 className="font-bold text-lg mb-2">Current User (Firebase Auth):</h3>
          <pre className="text-sm overflow-auto">
            {JSON.stringify(currentUser ? {
              uid: currentUser.uid,
              email: currentUser.email,
              displayName: currentUser.displayName
            } : null, null, 2)}
          </pre>
        </div>

        <div className="bg-gray-50 p-4 rounded">
          <h3 className="font-bold text-lg mb-2">User Profile (Firestore):</h3>
          <pre className="text-sm overflow-auto">
            {JSON.stringify(userProfile, null, 2)}
          </pre>
        </div>

        <div className="bg-gray-50 p-4 rounded">
          <h3 className="font-bold text-lg mb-2">Membership Data:</h3>
          <pre className="text-sm overflow-auto">
            {JSON.stringify(membership, null, 2)}
          </pre>
        </div>

        <div className="bg-gray-50 p-4 rounded">
          <h3 className="font-bold text-lg mb-2">Role Checks:</h3>
          <div className="space-y-2">
            <p>hasRole('admin'): {hasRole('admin') ? '✅ TRUE' : '❌ FALSE'}</p>
            <p>hasRole('member'): {hasRole('member') ? '✅ TRUE' : '❌ FALSE'}</p>
            <p>isActiveMember(): {isActiveMember() ? '✅ TRUE' : '❌ FALSE'}</p>
          </div>
        </div>

        <div className="bg-gray-50 p-4 rounded">
          <h3 className="font-bold text-lg mb-2">Expected vs Actual:</h3>
          <div className="space-y-2">
            <p><strong>Expected role:</strong> "admin"</p>
            <p><strong>Actual role:</strong> "{userProfile?.role}"</p>
            <p><strong>Expected membershipTier:</strong> "admin"</p>
            <p><strong>Actual membershipTier:</strong> "{userProfile?.membershipTier}"</p>
            <p><strong>Expected status:</strong> "approved"</p>
            <p><strong>Actual status:</strong> "{userProfile?.status}"</p>
          </div>
        </div>
      </div>
    </div>
  );
}
